import React, { useContext } from "react";
import commonContext from "../../../common/context/common";
interface IProps {
    label: string;
    name: string;
    value: string;
    checked?: boolean;
    onChange?: Function;
}
export default function RadioForm(props: IProps) {
    const { setLead } = useContext(commonContext);
    return (
        <>
            <label className="inline-flex items-center ml-0 md:ml-6 mb-3 md:mb-0 w-full md:w-3/12">
                <input
                    type="radio"
                    name={props.name}
                    onChange={async (e) => {
                        let state = {};
                        state[props.name] = e.target.value;
                        await setLead(state);
                        props.onChange(e);
                    }}
                    value={props.value}
                    checked={props.checked}
                />
                <span></span>{" "}
                <span className="ml-2 mt-1 text-sm md:text-base lg:text-xl">
                    {props.label}
                </span>{" "}
            </label>
        </>
    );
}
